/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AceitarConviteDto,
  AceiteResponse,
  ConvitePublicoResponse,
  ErroResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getConvitePublicoControllerDadosUrl = (token: string,) => {




  return `/v1/convites/${token}`
}

/**
 * @summary Dados do convite para a tela de aceite. E-mail vem travado.
 */
export const convitePublicoControllerDados = async (token: string, options?: Parameters<typeof httpClient>[1]): Promise<ConvitePublicoResponse> => {

  return httpClient<ConvitePublicoResponse>(getConvitePublicoControllerDadosUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getConvitePublicoControllerDadosQueryKey = (token: string,) => {
    return [
    `/v1/convites/${token}`
    ] as const;
    }


export const getConvitePublicoControllerDadosQueryOptions = <TData = Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError = ErroResponse>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConvitePublicoControllerDadosQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof convitePublicoControllerDados>>> = ({ signal }) => convitePublicoControllerDados(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConvitePublicoControllerDadosQueryResult = NonNullable<Awaited<ReturnType<typeof convitePublicoControllerDados>>>
export type ConvitePublicoControllerDadosQueryError = ErroResponse


export function useConvitePublicoControllerDados<TData = Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError = ErroResponse>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof convitePublicoControllerDados>>,
          TError,
          Awaited<ReturnType<typeof convitePublicoControllerDados>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConvitePublicoControllerDados<TData = Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof convitePublicoControllerDados>>,
          TError,
          Awaited<ReturnType<typeof convitePublicoControllerDados>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConvitePublicoControllerDados<TData = Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dados do convite para a tela de aceite. E-mail vem travado.
 */

export function useConvitePublicoControllerDados<TData = Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError = ErroResponse>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof convitePublicoControllerDados>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConvitePublicoControllerDadosQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getConvitePublicoControllerAceitarUrl = (token: string,) => {




  return `/v1/convites/${token}/aceitar`
}

/**
 * @summary Aceita o convite: cria a conta no ambiente e autentica
 */
export const convitePublicoControllerAceitar = async (token: string,
    aceitarConviteDto: AceitarConviteDto, options?: Parameters<typeof httpClient>[1]): Promise<AceiteResponse> => {

  return httpClient<AceiteResponse>(getConvitePublicoControllerAceitarUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(aceitarConviteDto)
  }
);}





export const getConvitePublicoControllerAceitarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convitePublicoControllerAceitar>>, TError,{token: string;data: AceitarConviteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof convitePublicoControllerAceitar>>, TError,{token: string;data: AceitarConviteDto}, TContext> => {

const mutationKey = ['convitePublicoControllerAceitar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convitePublicoControllerAceitar>>, {token: string;data: AceitarConviteDto}> = (props) => {
          const {token,data} = props ?? {};

          return  convitePublicoControllerAceitar(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvitePublicoControllerAceitarMutationResult = NonNullable<Awaited<ReturnType<typeof convitePublicoControllerAceitar>>>
    export type ConvitePublicoControllerAceitarMutationBody = AceitarConviteDto
    export type ConvitePublicoControllerAceitarMutationError = ErroResponse

    /**
 * @summary Aceita o convite: cria a conta no ambiente e autentica
 */
export const useConvitePublicoControllerAceitar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convitePublicoControllerAceitar>>, TError,{token: string;data: AceitarConviteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof convitePublicoControllerAceitar>>,
        TError,
        {token: string;data: AceitarConviteDto},
        TContext
      > => {
      return useMutation(getConvitePublicoControllerAceitarMutationOptions(options), queryClient);
    }
